import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Event } from 'src/app/utils/interfaces/old/agenda-interface';

@Component({
  selector: 'frg-event-box',
  templateUrl: './event-box.fragment.html',
  styleUrls: ['./event-box.fragment.scss']
})
export class EventBoxFragment implements OnInit {

  @Input() public event: Event;
  @ViewChild('typeColor') public typeColorElement: ElementRef;

  constructor(
    public el: ElementRef,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    if (this.event
      && this.event.type && this.event.type.id !== ''
      && this.event.type.couleur && this.event.type.couleur !== '') {
      this.setColor();
    }
  }

  private setColor() {
    if (this.typeColorElement) {
      this.renderer.setStyle(this.typeColorElement.nativeElement, 'background-color', this.event.type.couleur);
    } else {
      setTimeout(() => {
        this.setColor();
      }, 10);
    }
  }

}
